import React from 'react'
import { Skeleton } from '@mui/material';

const CartSkeleton = () => {
    return (
        <div className='flex flex-row justify-between cursor-pointer bg-white shadow p-3 rounded'>
            <div className='flex flex-row space-x-4'>
                <Skeleton variant='circular' height={40} width={40} />
                <div className='space-y-1'>
                    <Skeleton variant='text' sx={{ fontSize: '.7rem' }} width={150} />
                    <Skeleton variant='text' sx={{ fontSize: '.5rem' }} />
                </div>
            </div>

            <div className='flex flex-row space-x-10 items-center'>
                <div className='flex flex-row items-center space-x-4'>
                    <Skeleton variant="circular" height={24} width={24} />
                    <Skeleton variant="circular" height={24} width={24} />
                </div>

                <Skeleton variant="circular" height={24} width={24} />
            </div>
        </div>
    )
}

export default CartSkeleton